import {Box} from "@mui/material";
import {useTrackScreenVisit} from "crqlar-react-common/dist/utils/analytics.util";
import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import EditCanvasContainer from "./v2/EditCanvasContainer";
import {useFullscreenSnackbarAnchor} from "../../layout/DashboardSnackbarProvider";

const EditFloorplan = () => {
    useTrackScreenVisit("edit floorplan");
    useFullscreenSnackbarAnchor();

    const {restaurantId} = useParams();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const returnTo = searchParams.get("returnTo");

    const navigateBack = () => {
        if (returnTo) {
            navigate(returnTo);
        } else {
            navigate(-1);
        }
    };

    return (
        <Box
            component="main"
            sx={{
                width: "100vw",
                height: "100dvh",
                minWidth: 0,
                minHeight: 0,
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
                boxSizing: "border-box",
                bgcolor: "background.default",
                px: {xs: 1, md: 2},
                pb: {xs: 1, md: 1.5},
                "@supports not (height: 100dvh)": {
                    height: "100vh",
                },
            }}
        >
            <EditCanvasContainer
                restaurantId={restaurantId!}
                onSaved={navigateBack}
                onBack={navigateBack}
            />
        </Box>
    );
};

export default EditFloorplan;
